const commissionDetailsReport = {
  employeeName: null,
  assignmentGrossProfitItems: [],
  directPlacementGrossProfitItems: [],
  teamMembersGrossProfitItems: [],
  commissionTiers: [],
  consultantsGP: null,
  permPlacementGP: null,
  totalIndividualGP: null,
  commissionOverridePercentage: null,
  commissionOverride: null,
  totalCommission: null
}

export default () => Object.assign({}, commissionDetailsReport)
